<template>
  <div class="app-main-content">
    <div class="details-view" style="overflow: auto">
      <!--按钮-->
      <div v-if="!isDialog">
        <el-button v-if="isEdit" type="primary" no="Cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-if="isEdit" type="primary" no="Save" @click="save">{{ $t('CargoMsg.Cargo_SaveDraft') }}</el-button>
        <el-button v-if="isEdit" type="primary" no="Save" @click="publishDirectly">{{ $t('CargoMsg.Cargo_PublishDirectly') }}</el-button>
        <el-button v-if="!isEdit" type="primary" no="Back" @click="$emit('back')">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button v-if="!look && !isEdit" :disabled="form.status === SystemConstants.PRICE_STATUS_NORMAL.code" type="primary" no="Edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
      </div>
      <div class="main-content" style="width: fit-content; margin-top: 5px">
        <div style="display: flex">
          <!--基本信息-->
          <div class="section form-column" style="width: 900px">
            <el-form
              :disabled="!isEdit"
              label-width="140px"
              label-position="right"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
              <!--港前运价编号-->
              <el-form-item :label="$t('CargoMsg.Cargo_PortPreRateCode')">
                <el-input :value="form.priceNo" disabled />
              </el-form-item>
              <!--运价类型-->
              <el-form-item :label="$t('Pricing.PriceType')" required>
                <el-radio-group v-model="form.priceMethod" @change="form.branchLine = form.priceMethod === SystemConstants.PRICE_METHOD_DIRECT.code ? 0 : form.branchLine">
                  <el-radio :label="SystemConstants.PRICE_METHOD_DIRECT.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_DirectHaul') }}</el-radio>
                  <el-radio :label="SystemConstants.PRICE_METHOD_BRANCH.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_SideLine') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!--支线类型-->
              <el-form-item
                v-if="form.priceMethod === SystemConstants.PRICE_METHOD_BRANCH.code"
                :label="$t('CargoMsg.Cargo_SideLineType')"
                required
              >
                <cargo-advance-select
                  no="branchLine"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="form.branchLine"
                  :static-options="SystemConstants.BRANCH_LINES"
                  @parentCallBack="p=>{form.branchLine=p.value}"
                />
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_OriginAreaSelection')"
                label-width="140px"
                required
              >
                <el-button v-if="isEdit" type="danger" @click="addArea">{{ $t('CargoMsg.Cargo_AddArea') }}</el-button>
              </el-form-item>
              <div v-for="(priceRegion, index) in form.priceRegions" :key="index">
                <el-form :disabled="!isEdit" :inline="true" label-position="right" class="form-item-200">
                  <div style="display: flex; margin-top: 5px">
                    <cargo-area
                      no="area"
                      country="CN"
                      :province.sync="priceRegion.province"
                      :city.sync="priceRegion.city"
                      :district.sync="priceRegion.districts"
                      :town.sync="priceRegion.townUuid"
                      :show-town="true"
                      :select-width="150"
                      style="display: inline-block"
                    />
                    <i v-if="isEdit" style="color: #f56c6c; cursor: pointer; margin-top: 5px; font-size: 18px" class="el-icon-remove" @click="delArea(index)" />
                  </div>
                </el-form>
                <!--详细地址 -->
                <el-form-item
                  :label="$t('Partners.detailAddress')"
                >
                  <el-input v-model="priceRegion.detailAddress" type="textarea" :rows="3" />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <!--起运港信息-->
          <div class="section form-column" style="width: 603px">
            <el-form
              :disabled="!isEdit"
              label-width="140px"
              label-position="right"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_OriginPortInfo') }}</span>
              <!--起运港-->
              <el-form-item :label="$t('CargoMsg.Cargo_POL')" required>
                <el-tabs v-model="form.portType" @tab-click="form.pol = ''">
                  <el-tab-pane :disabled="!isEdit" :label="$t('CargoMsg.Cargo_Harbour')" :name="SystemConstants.PORT_TYPE_SEAPORT.code" />
                  <el-tab-pane :disabled="!isEdit" :label="$t('CargoMsg.Cargo_Airport')" :name="SystemConstants.PORT_TYPE_AIRPORT.code" />
                </el-tabs>
                <cargo-advance-select
                  v-if="form.portType === SystemConstants.PORT_TYPE_SEAPORT.code"
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.pol"
                  style="width:100%"
                  @parentCallBack="p=>form.pol=p.value"
                />
                <cargo-advance-select
                  v-if="form.portType === SystemConstants.PORT_TYPE_AIRPORT.code"
                  :select-type="TYPE_NAMES.basic_data_Airport"
                  filterable
                  :default-value="form.pol"
                  style="width:100%"
                  @parentCallBack="p=>form.pol=p.value"
                />
              </el-form-item>
              <!--码头-->
              <el-form-item :label="$t('SeaExport.Wharf')">
                <el-input v-model="form.wharf" />
              </el-form-item>
              <!--供应商【船公司 or 卡车公司】-->
              <el-form-item :label="$t('CargoMsg.Cargo_Vendor')">
                <cargo-company-select
                  ref="supplier"
                  no="supplier"
                  :method-params="{active:true, subCondition:{seaCmp:true, truckCmp:true, collectionType: 'or'}}"
                  :default-value="form.supplier||0"
                  @change="p=>{form.supplier=p.value||0}"
                />
              </el-form-item>
              <!--有效期-->
              <el-form-item :label="$t('Pricing.BeginDate')" required>
                <el-date-picker
                  v-model="form.beginDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="{
                    disabledDate: time => {
                      return form.endDate && time.getTime() >= new Date(form.endDate.length <= 10 ? form.endDate + ' 00:00:00' : form.endDate).getTime()
                    }
                  }"
                />
                -
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="{
                    disabledDate: time => {
                      return form.beginDate && time.getTime() <= new Date(form.beginDate.length <= 10 ? form.beginDate + ' 00:00:00' : form.beginDate).getTime()
                    }
                  }"
                />
              </el-form-item>
              <!--备注-->
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input v-model="form.remarks" type="textarea" :rows="3" />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!--运价信息-->
        <div class="section" style="width:100%">
          <span class="title">{{ $t('Pricing.PriceInfo') }}</span>
          <!--按箱型计费条目-->
          <span>{{ $t('CargoMsg.Cargo_ChargeByContainerType') }}</span>
          <div v-if="isEdit" style="margin-top: 5px;">
            <el-button type="primary" @click="addChargingItem(SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button type="danger" @click="delChargingItem(SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050222"
              :grid-options="chargingItemByEqSize.gridOptions"
              :column-defs="getColumnDefsByEqSize"
              :row-data="form.byEqSizeChargingItems"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{chargingItemByEqSize.gridApi=params.api}"
            />
          </div>
          <!--非按箱型计费条目-->
          <span>{{ $t('CargoMsg.Cargo_ChargeNotByContainerType') }}</span>
          <div v-if="isEdit" style="margin-top: 5px;">
            <el-button type="primary" @click="addChargingItem(SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button type="danger" @click="delChargingItem(SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050223"
              :grid-options="chargingItemNotByEqSize.gridOptions"
              :column-defs="getColumnDefsNotByEqSize"
              :row-data="form.notByEqSizeChargingItems"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{chargingItemNotByEqSize.gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />
  </div>
</template>

<script>
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import PricePrePortLastMileDetail from './pricePrePortLastMileDetail'
import { PricePrePortLastMile } from '@/class/model/price/PricePrePortLastMile'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import cargoArea from '@/components/Cargo/Common/cargoArea'

export default {
  name: 'PricePrePortDetail', // 港前运价-详情
  components: { CargoAiRecognitionDialog, cargoAgGridWrapper, cargoAdvanceSelect, cargoCompanySelect, cargoArea },
  props: {
    look: { type: Boolean, default: false },
    isDialog: { type: Boolean, default: false } // 详情 是否 作为弹窗
  },
  data() {
    return {
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.REGION_PROMPT_KEY.code,
        visible: false
      },
      currentAreaIndex: 0,
      type: SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code,
      ColumnUtils,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      chargingItemByEqSize: { // 按箱型计费条目
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.chargingItemByEqSize.selectedRows = this.chargingItemByEqSize.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.selectedRow = event.data
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor
          }
        },
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      chargingItemNotByEqSize: { // 非按箱型计费条目
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.chargingItemNotByEqSize.selectedRows = this.chargingItemNotByEqSize.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.selectedRow = event.data
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      isEdit: false, // 是否 编辑

      chargeItemSet: new Set(),
      form: new PricePrePortLastMile().fillDefaultValue().getData(),
      originForm: {}
    }
  },
  computed: {
    getColumnDefsByEqSize() {
      return this.getChargingItemByEqSizeDefs()
    },
    getColumnDefsNotByEqSize() {
      return this.getChargingItemNotByEqSizeDefs()
    }
  },
  created() {
    this.init()
  },
  methods: PricePrePortLastMileDetail.methods
}
</script>

<style scoped lang="scss">
</style>
